/**
 * QuickTime Movie Tranformation Matrix description:
 * https://developer.apple.com/library/archive/documentation/QuickTime/RM/MovieBasics/MTEditing/K-Chapter/11MatrixFunctions.html
 *
 * Values by indices 0, 1, 3, 4 can be a result of scaling and rotation trasformations matrices multiplication
 * We need to calculate Degrees Rotated given Tranformation Matrix
 *
 * Reference function in FFmpeg that performs this
 * calculation from transformation matrix to degrees:
 * https://github.com/FFmpeg/FFmpeg/blob/870bfe16a12bf09dca3a4ae27ef6f81a2de80c40/libavutil/display.c#L34
 *
 *
 * This is the same implementation in TS.
 *
 * @see also:
 * Math.hypot
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/hypot
 *
 * Math.atan2
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan2
 *
 */

/*
 * Convert Fixed https://developer.apple.com/documentation/kernel/fixed/ to double value
 * First 16 bits are used for the integer part
 * Last 16 bits are used for the decimal part
 */
const convertFixedPoint = (fixPointNum: number) => fixPointNum / (1 << 16);

export const computeDisplayRotationDegrees = (matrix: number[] | null): number | undefined => {
    if (!matrix || matrix.length === 0) {
        return undefined;
    }

    const scale: [number, number] = [
        Math.hypot(convertFixedPoint(matrix[0] ?? 0), convertFixedPoint(matrix[3] ?? 0)),
        Math.hypot(convertFixedPoint(matrix[1] ?? 0), convertFixedPoint(matrix[4] ?? 0)),
    ];

    if (scale[0] === 0 || scale[1] === 0) {
        return undefined;
    }

    const rotation =
        (Math.atan2(convertFixedPoint(matrix[1] ?? 0) / scale[1], convertFixedPoint(matrix[0] ?? 0) / scale[0]) * 180) /
        Math.PI;

    return -1 * rotation;
};
